import axios from 'axios';

const state = {
  claimStatuses: [],
  companyStatuses: [],
  discountUnitTypes: [],
  jobStatuses: [],
  leadFollowUpTypes: [],
  leadStatuses: [],
  moveSizes: [],
  moverStatuses: [],
  paymentMethods: [],
  paymentTypes: [],
  sources: [],
  states: [],
  truckStatuses: [],
  userStatuses: [],
};

const getters = {};

const mutations = {
  setClaimStatuses: (st, payload) => {
    st.claimStatuses = payload;
  },
  setJobStatuses: (st, payload) => {
    st.jobStatuses = payload;
  },
  setLeadFollowUpTypes: (st, payload) => {
    st.leadFollowUpTypes = payload;
  },
  setLeadStatuses: (st, payload) => {
    st.leadStatuses = payload;
  },
  setSources: (st, payload) => {
    st.sources = payload;
  },
  setCompanyStatuses: (st, payload) => {
    st.companyStatuses = payload;
  },
  setStates: (st, payload) => {
    st.states = payload;
  },
  setMoveSizes: (st, payload) => {
    st.moveSizes = payload;
  },
  setMoverStatuses: (st, payload) => {
    st.moverStatuses = payload;
  },
  setTruckStatuses: (st, payload) => {
    st.truckStatuses = payload;
  },
  setUserStatuses: (st, payload) => {
    st.userStatuses = payload;
  },
  setPaymentMethods: (st, payload) => {
    st.paymentMethods = payload;
  },
  setPaymentTypes: (st, payload) => {
    st.paymentTypes = payload;
  },
  setDiscountUnitTypes: (st, payload) => {
    st.discountUnitTypes = payload;
  },
};

const actions = {
  getJobStatuses: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/job-statuses`)
        .then(res => {
          commit('setJobStatuses', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getLeadFollowUpTypes: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/lead-follow-up-types`)
        .then(res => {
          commit('setLeadFollowUpTypes', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getLeadStatuses: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/lead-statuses`)
        .then(res => {
          commit('setLeadStatuses', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getClaimStatuses: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/claim-statuses`)
        .then(res => {
          commit('setClaimStatuses', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getSources: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/sources`)
        .then(res => {
          commit('setSources', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getCompanyStatuses: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/company-statuses`)
        .then(res => {
          commit('setCompanyStatuses', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getStates: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/states`)
        .then(res => {
          commit('setStates', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getMoveSizes: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/move-sizes`)
        .then(res => {
          commit('setMoveSizes', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getMoverStatuses: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/mover-statuses`)
        .then(res => {
          commit('setMoverStatuses', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getTruckStatuses: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/truck-statuses`)
        .then(res => {
          commit('setTruckStatuses', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getUserStatuses: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/user-statuses`)
        .then(res => {
          commit('setUserStatuses', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getPaymentMethods: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/payment-methods`)
        .then(res => {
          commit('setPaymentMethods', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getPaymentTypes: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`values/payment-types`)
        .then(res => {
          commit('setPaymentTypes', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getDiscountUnitTypes: ({ commit }) => {
    axios.get('/values/discount-unit-types').then(res => {
      commit('setDiscountUnitTypes', res.data.data);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/values.js